import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

import Stack from '@mui/material/Stack';

import { PracticeSession } from '../../types';

import ToMainMenuButton from '@ts-core/components/ToMainMenuButton';
import Button from '@ts-core/components/Button';
import PageContentLayout from '@ts-core/core/components/PageContentLayout';
import StudentPracticeSessionsList from '@ts-core/modules/practice/components/StudentPracticeSessionsList';

import { usePracticeSessions, useAvailableExercises } from '../../hooks';
import CreatePracticeSessionDialog, { useCreatePracticeSessionDialog } from 'modules/practice/components/CreatePracticeSessionDialog';

const PracticeSessionsListPage = () => {
  const intl = useIntl();
  const { courseId } = useParams<{ courseId: string }>();
  const history = useHistory();
  const { availableExercisesCount } = useAvailableExercises({ courseId });
  const { practiceSessions, loading } = usePracticeSessions({ courseId });

  const { dialogProps, onOpenCreatePracticeSessionDialog } = useCreatePracticeSessionDialog();

  const handlePracticeSessionActionClick = useCallback(
    (practiceSession: PracticeSession) => {
      if (practiceSession.finished) {
        history.push(`/${courseId}/practice/${practiceSession._id}/results`);
      } else {
        history.push(`/${courseId}/practice/${practiceSession._id}/do`);
      }
    },
    [history, courseId]
  );

  return (
    <>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <ToMainMenuButton title={intl.formatMessage({ id: 'quickLink.practiceSessions' })} />
        {availableExercisesCount > 0 && (
          <Button onClick={onOpenCreatePracticeSessionDialog} color="secondary">
            {intl.formatMessage({ id: 'practice' })}
          </Button>
        )}
      </Stack>
      <PageContentLayout>
        <StudentPracticeSessionsList
          practiceSessions={practiceSessions}
          loading={loading}
          availableExercisesCount={availableExercisesCount}
          onPracticeSessionActionClick={handlePracticeSessionActionClick}
        />
      </PageContentLayout>
      <CreatePracticeSessionDialog {...dialogProps} />
    </>
  );
};

export default PracticeSessionsListPage;
